import styled from "styled-components"

export const Section = styled.section`
  background: #000;
  margin-left: -1px;
  margin-right: -1px;
  padding: 5px 0px;
  @media (min-width: 999px) {
    padding: 50px 0px;
  }
`
export const Container = styled.div`
  max-width: 800px;
  margin: auto;
`
export const Inner = styled.div`
  padding: 4em;
`
export const Title = styled.h2`
  font-family: Oswald, sans-serif !important;
  padding: 8px 0;
  margin: 0;
  color: #FFFFFF;
  text-align: center;
`
